import Default from '@/components/layout/Default';

export const MOTOR_ORIGIN_CUSTOMER = 'CUSTOMER_PORTAL';

export function isCustomerMotorV2Enabled() {
  const v = process.env.VUE_APP_CUSTOMER_MOTOR_V2;
  return v === 'true' || v === '1';
}

/**
 * Resolve the motor V2 buy route from a legacy {q, b} query (quoteId, riskId).
 * Returns null when V2 is disabled or the query isn't a motor quote
 * (motor uses a numeric riskId for `b`; health/dp/travel use string codes).
 */
export function resolveMotorV2BuyRoute(query) {
  if (!isCustomerMotorV2Enabled()) return null;
  const quoteId = query?.q;
  const riskId = query?.b;
  if (!quoteId || !/^\d+$/.test(String(riskId))) return null;
  return {
    name: 'CustomerMotorApply',
    query: { quoteId: String(quoteId), riskId: String(riskId) },
  };
}

export function getMotorChannelConfig() {
  return {
    channel: 'customer',
    layout: Default,
    prodId: 3437,
    routes: {
      products: 'CustomerProductSelect',
      start: 'CustomerMotorStart',
      apply: 'CustomerMotorApply',
      finalization: 'CustomerMotorFinalization',
      dashboard: 'Dashboard',
      legacyRequest: 'Request',
    },
    labels: {
      startBreadcrumb: 'Buy cover / Motor',
      startTitle: 'Motor insurance — Get a quote',
      applyBreadcrumb: 'Motor / Application',
      applyTitle: 'Complete your application',
      newSaleSub: 'This will clear your current motor application progress.',
    },
    saleSteps: ['Your details', 'Vehicle', 'Branch', 'Payment'],
  };
}

export { getCognitoIdentityProfile } from '@/utils/paChannel';
